const DeductItem = () => import('@/views/main/live/deductItem/DeductItem.vue')
export default {
  path: '/main/live/deductItem',
  name: 'DeductItem',
  component: DeductItem,
  children: []
}
